if (!customElements.get('card-variant-picker')) {
  class CardVariantPicker extends HTMLElement {
    connectedCallback() {
      this.variantData = JSON.parse(
        this.querySelector('.card-variant-json').textContent
      );

      this.select = this.querySelector('.card__variant-select');
      this.priceBox = this.querySelector('.card__custom-price-box');
      this.savingBadge = this.priceBox.querySelector('.saving-badge');
      this.priceCompare = this.priceBox.querySelector('.price-compare');
      this.priceRegular = this.priceBox.querySelector('.price-regular');

      this.defaultOptions = this.dataset.defaultOptions
        ? this.dataset.defaultOptions.split('|||')
        : [];

      this.select.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      const selectedValue = this.select.value;
      const optionValues = [selectedValue, ...this.defaultOptions];
      const variant = this.findVariant(optionValues);
      if (variant) this.updatePrice(variant);
    }

    findVariant(optionValues) {
      return this.variantData.find((variant) =>
        variant.options.every((opt, i) => opt === optionValues[i])
      );
    }

    updatePrice(variant) {
      const hasSale =
        variant.compare_at_price > variant.price && variant.available;

      this.priceRegular.textContent = variant.price_formatted;
      this.priceRegular.classList.toggle('price--sale', hasSale);

      if (hasSale) {
        const saving = Math.round(
          ((variant.compare_at_price - variant.price) /
            variant.compare_at_price) *
            100
        );
        this.savingBadge.textContent = 'Save ' + saving + '%';
        this.savingBadge.style.display = '';
        this.priceCompare.textContent = variant.compare_at_price_formatted;
        this.priceCompare.style.display = '';
      } else {
        this.savingBadge.style.display = 'none';
        this.savingBadge.textContent = '';
        this.priceCompare.style.display = 'none';
        this.priceCompare.textContent = '';
      }

      const cardWrapper = this.closest('.card-wrapper');
      if (cardWrapper) {
        const variantInput = cardWrapper.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.value = variant.id;
          variantInput.disabled = !variant.available;
        }

        const soldOutBtn = cardWrapper.querySelector(
          '.quick-add__submit[data-sold-out-message]'
        );
        if (soldOutBtn) {
          soldOutBtn.disabled = !variant.available;
          const btnText = soldOutBtn.querySelector('.btn__text');
          if (btnText) {
            btnText.textContent = variant.available ? 'Add' : 'Sold out';
          }
        }
      }
    }
  }

  customElements.define('card-variant-picker', CardVariantPicker);
}
